import React from "react"
import BaseIcon from "./BaseIcon"

const SwiperArrowRight = ({ color, ...props }) => (
    <BaseIcon
        {...props}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1 1L9 9L1 17"
            stroke={color ? color : "#27272D"}
            strokeWidth="2"
        />
    </BaseIcon>
)

export default SwiperArrowRight
